'use client';

let IMAGE_OPTIMIZATION_API_FROM_CORE = null;

try {
  // Try to require the module if it exists.
  const coreImageConfig = require('@eliadmin/core/next-images-optimization-api-url');
  IMAGE_OPTIMIZATION_API_FROM_CORE = coreImageConfig.IMAGE_OPTIMIZATION_API_FROM_CORE;
} catch (error) {
  console.error('Module @eliadmin/core/next-images-optimization-api-url not found:', error);
  IMAGE_OPTIMIZATION_API_FROM_CORE = null; // Fallback in case the module is not available.
}

export default function myImageLoader({ src, width, quality }) {
  if (!src || /^(data:|blob:)/i.test(src)) return src;
  const isLocal = !/^https?:\/\//i.test(src) && !src.startsWith('//');

  const imageOptimizationApi =
    process.env.IMAGE_OPTIMIZATION_API ??
    IMAGE_OPTIMIZATION_API_FROM_CORE ??
    'https://eliadmin.b-cdn.net/image';

  const baseUrl = process.env.NEXT_PUBLIC_APP_URL;

  if (isLocal && process.env.NODE_ENV === 'development') {
    return src;
  }
  if (isLocal && !baseUrl) return src;
  const fullSrc = isLocal ? new URL(src, baseUrl).href : src.startsWith('//') ? `https:${src}` : src;
  // Preserve API parameters (e.g. ?ai=0). A second '?' makes width part of ai's value.
  const optimized = new URL(`${imageOptimizationApi.replace(/\/$/, '')}/${fullSrc}`);
  if (width) optimized.searchParams.set('width', String(width));
  optimized.searchParams.set('quality', String(quality ?? 75));
  return optimized.href;
}
